import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Base64 } from 'js-base64';
import { Person } from '../../@core/data/person';
import { JurPerson } from '../../@core/data/jur-person';
import { SmartTableData } from '../../@core/data/smart-table';
import { RestService } from '../../@core/utils/rest.service';
import { Ng2SmartTableModule, LocalDataSource } from 'ng2-smart-table';
import { NcalayerService } from '../../@core/utils/ncalayer/ncalayer.service';
import { Result } from '../../@core/data/result';
import { CustomEditorComponent10 } from '../payment/custom-editor.component.10';
import { CustomEditorComponent6 } from '../payment/custom-editor.component.6';
import Swal from 'sweetalert2';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CustomEditorComponent11 } from '../payment/custom-editor.component.11';
import { CustomEditorComponent12 } from '../payment/custom-editor.component.12';
import { CustomEditorComponent13 } from '../payment/custom-editor.component.13';
import { CustomEditorComponent14 } from '../payment/custom-editor.component.14';
import { CustomEditorComponent16 } from '../payment/custom-editor.component.16';
import { NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
});
export interface Persons {
  BEGINDATE: string;
  BIRTHDATE: string;
  EDIT: string;
  ENDDATE: string;
  FM: string;
  FT: string;
  G_PERSON: string;
  IDN: string;
  NM: string;
  PERIOD: string;
  SUM: string;
}
class PersonsClass implements Persons {
  constructor(
    public BEGINDATE: string,
    public BIRTHDATE: string,
    public EDIT: string,
    public ENDDATE: string,
    public FM: string,
    public FT: string,
    public G_PERSON: string,
    public IDN: string,
    public NM: string,
    public PERIOD: string,
    public SUM: string,

  ) { }

}
export interface Employees {
  BIN: string;
  Persons: Person[];
  token: string;
  lang: string;
}

class EmployeesClass implements Employees {

  public BIN: string;
  public Persons: Person[];
  public token: string;
  public lang: string;

}

@Component({
  selector: 'ngx-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.scss']
})
export class EmployeeComponent implements OnInit, AfterViewInit {



  public smatTable: SmartTableData;
  data1: any;
  test: string;
  objectLang: any;
  settings: any
  token: any;
  noDatValue: any;
  saveButtonDisabled: Boolean = true;

  ngAfterViewInit() {

    let pattern = `<a id="search__button" class="ng2-smart-action ng2-smart-action-add-add ng-star-inserted" href="#" style="margin-bottom: 7px; font-size: 15px !important; font-weight: 500;"></a>`;

    let el = document.querySelector('.ng2-smart-actions-title-add');
    

    var newItem = document.createElement("DIV");
    newItem.innerHTML = pattern;

    el.insertBefore(newItem, el.childNodes[0]);

    let searchButton = document.getElementById("search__button");

    searchButton.innerHTML = sessionStorage.getItem('lang') == "0" ? "Поиск" : "Іздеу";

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.translate.use(event.lang);
      searchButton.innerHTML = event.lang == "ru" ? "Поиск" : "Іздеу";
    });

    searchButton.addEventListener('click', (ev) => {
      ev.preventDefault();
    });
  }

  translateLang() {


    let actionValue = "";
    this.noDatValue = sessionStorage.getItem('lang') == "0" ? "Нет данных" : "Мәлімет жоқ";

    let x = setInterval(() => {
      let elem = document.getElementsByClassName('ng2-smart-title')[0];

      actionValue = sessionStorage.getItem('lang') == "0" ? "Действия" : "Әрекет";
      this.noDatValue = sessionStorage.getItem('lang') == "0" ? "Нет данных" : "Мәлімет жоқ";
      if (typeof elem !== "undefined" && sessionStorage.getItem('lang') !== null) {
        elem.innerHTML = actionValue;
        var tds = document.getElementsByTagName("td");
        for (var x = 0; x < tds.length; x++)
          if (tds[x].innerHTML == "Нет данных" || tds[x].innerHTML == "Мәлімет жоқ")
            tds[x].innerHTML = this.noDatValue
        clearInterval(x);
      }
    }, 10);

    this.settings = {

      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmCreate: true,
      },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        onDeleteConfirm: true,
        confirmDelete: true,
      },
      pager: {
        display: true,
        perPage: 15
      },
      noDataMessage: this.noDatValue,
      actions: {
        columnTitle: actionValue,
      },
      columns: {
        index: {
          title: "№",
          type: "text",
          width: '3%',
          editable: false, addable: false,
          valuePrepareFunction(value, row, cell) { return (cell.row.index + 1); }
        },

        IDN: {
          title: this.translate.instant('IIN'),
          editable: true,
          width: '14%',
          type: 'html',
          editor: {
            type: 'custom',
            component: CustomEditorComponent10,
          },
        },
        FM: {
          title: this.translate.instant('LASTNAME'),
          editor: {
            type: 'custom',
            component: CustomEditorComponent12,
            uppercase: true
          },
        },
        NM: {
          title: this.translate.instant('FIRSTNAME'),
          editor: {
            type: 'custom',
            component: CustomEditorComponent13,
            uppercase: true
          },
        },
        FT: {
          title: this.translate.instant('MIDDLENAME'),
          editor: {
            type: 'custom',
            component: CustomEditorComponent14,
            uppercase: true
          },
        },
        BIRTHDATE: {
          title: this.translate.instant('BIRTHDAY'),
          width: '12%',
          editor: {
            type: 'custom',
            component: CustomEditorComponent6,
          },
        },

        BEGINDATE: {
          title: this.translate.instant('STARTDAY'),
          editor: {
            type: 'custom',
            component: CustomEditorComponent11,
          },
        },
        ENDDATE: {
          title: this.translate.instant('ENDDAY'),
          editor: {
            type: 'custom',
            component: CustomEditorComponent16,
          },
        }


      }
    };


  }


  source: LocalDataSource = new LocalDataSource();
  subscription: any;
  jurPerson: JurPerson;
  personsN: Person[];
  personsN2: Person[];
  constructor(
    public rest: RestService,
    private service: SmartTableData,
    public ncalayer: NcalayerService,
    private router: Router,
    private toastrService: NbToastrService,
    public translate: TranslateService) {
    const data = this.service.getData();
    this.source.load(data);


  }

  ngOnInit() {

    try {

      this.translateLang();
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.translate.use(event.lang);
        this.translateLang();
      });
      if (!sessionStorage.getItem('jurPerson')) {
        Swal.fire({
          text: this.translate.instant('ALERTTECHNICAL'),
          type: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: "#008e54"
        })
        this.router.navigate(['/auth/login']);
      }
      else {
        this.rest.getJurPerson(sessionStorage.getItem('jurPerson')).subscribe((data: Result) => {
          console.log(data);
          if (data.code == '0') {
            try {
              sessionStorage.setItem('errorMessage', '');
              this.token = JSON.parse(sessionStorage.getItem('jurPerson')).token;
              let base64 = data.message.toString();
              let jsonString = Base64.decode(base64);
              this.jurPerson = JSON.parse(jsonString);
              this.personsN = this.jurPerson.persons;
              sessionStorage.setItem('persons', JSON.stringify(this.personsN));
              console.log(this.jurPerson);
              this.personsN2 = this.jurPerson.persons;
              for (let i = 0; i < this.personsN.length; i++) {
                this.personsN[i].FM = this.replaceKaz(this.personsN[i].FM);
                this.personsN[i].NM = this.replaceKaz(this.personsN[i].NM);
                this.personsN[i].FT = this.replaceKaz(this.personsN[i].FT);


              }
            }
            catch (e) {
              sessionStorage.setItem('errorMessage', e.message);
              sessionStorage.setItem('jurPerson', '');
              console.error('error - 1 - ' + e.message);
              Swal.fire({
                text: this.translate.instant('ALERTTECHNICAL'),
                type: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: "#008e54"
              })
            }
          }
          if (data.code == '-4') {
            Swal.fire({
              text: data.message,
              type: 'warning',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
            sessionStorage.setItem('jurPerson', '');
            sessionStorage.setItem('jurName', '');

            this.router.navigate(['/auth']);
          }
          if (data.code == '-1') {
            sessionStorage.setItem('errorMessage', data.message);
            sessionStorage.setItem('jurPerson', '');
            sessionStorage.setItem('jurName', '');
            console.error('error - 2 - ' + data.message);
            Swal.fire({
              text: this.translate.instant('ALERTTECHNICAL'),
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
          }
        });
      }
    }
    catch (e) {
      console.log('Servis are not working')
      console.error(e.message);
    }

  }
  // onDeleteConfirm(event) {
  //   if (window.confirm('Are you sure you want to delete?')) {
  //     this.personsN.splice( this.personsN.indexOf(event.data), 1 );
  //     event.confirm.resolve();
  //   } else {
  //     event.confirm.reject();
  //   }
  // }


  pp: any[] = [];

  onSaveConfirm(event) {
    this.saveButtonDisabled = false;
    //this.personsN2= this.getUnique(this.personsN2,'IDN');
    this.personsN = this.getUnique(this.personsN, 'IDN');
    //event.newData.ENDDATE = "";
    event.newData.EDIT = '1';
    //console.log ('eventNew'+event.newData);
    this.pp.push(event.newData);
    this.pp = this.getUnique(this.pp, 'IDN');
    event.confirm.resolve(event.newData);
  }
  getUnique(arr, comp) {

    const unique = arr
      .map(e => e[comp])

      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter(e => arr[e]).map(e => arr[e]);

    return unique;
  }
  checkIin(Name: any): boolean {

    if (Name.length != 12) return false;
    if (!(/[0-9]{12}/.test(Name))) return false;
    var b1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    var b2 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
    var a = [];
    var controll = 0;
    for (var i = 0; i < 12; i++) {
      a[i] = parseInt(Name.substring(i, i + 1));
      if (i < 11) controll += a[i] * b1[i];
    }
    controll = controll % 11;
    if (controll == 10) {
      controll = 0;
      for (var i = 0; i < 11; i++)
        controll += a[i] * b2[i];
      controll = controll % 11;
    }
    if (controll != a[11]) { return false; }
    for (let i = 0; i < this.personsN.length; i++) {
      if (Name == this.personsN[i].IDN) {
        return false;
      }

    }
    return true;
  }

  onCreateConfirm(event) {
    this.saveButtonDisabled = true;
    if (event.newData.IDN.length == 0) {
      Swal.fire({
        text: this.translate.instant('ALERTIINEMP'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
    if (this.checkIin(event.newData.IDN) == false) {
      Swal.fire({
        text: this.translate.instant('ALERTERR'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
    if (event.newData.FM.length == 0) {
      Swal.fire({
        text: this.translate.instant('ALERTFILLLASTNAME'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
    if (event.newData.NM.length == 0) {
      Swal.fire({
        text: this.translate.instant('ALERTFILLNAME'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
    if (event.newData.BIRTHDATE.length == 0) {
      Swal.fire({
        text: this.translate.instant('ALERTFILLBDATE'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }
    if (event.newData.IDN.length != 0 && this.checkIin(event.newData.IDN) == true &&
      event.newData.BIRTHDATE.length != 0 && event.newData.FM.length != 0 &&
      event.newData.NM.length != 0) {
      this.pp.push(event.newData);
      // event.newData.ENDDATE = "";
      event.newData.EDIT = '1';
      event.newData.SUM = '0';
      event.confirm.resolve(event.newData);

      this.saveList();
    } else {
      event.confirm.reject();
    }



    // this.pp.push(event.newData);  
    // event.newData.ENDDATE = "";
    // event.newData.EDIT='1';
    // console.log ('eventNewCreate'+event.newData);
    // this.pp= this.getUnique(this.pp,'BIN');
    // event.confirm.resolve(event.newData); 
    // console.log('event confirm'+event)
    //   event.newData.EDIT='1';
    //   this.personsN2.push(event.newData);
    // //  event.newData['name'] += ' + added in code';
    // this.personsN2= this.getUnique(this.personsN2,'IDN');
    // this.personsN= this.getUnique(this.personsN,'IDN');
    //   event.confirm.resolve(event.newData);
    // this.personsN2= this.getUnique(this.personsN2,'IDN');
    // this.personsN= this.getUnique(this.personsN,'IDN');
    // this.pp= this.getUnique(this.pp,'IDN');



  }

  addNull(num) {
    if (num < 10) return "0" + num;
    return num.toString();
  }

  onDeleteConfirm(event): void {
    this.saveButtonDisabled = false;
    if (true) {

      let pt = new EmployeesClass();
      pt.lang = sessionStorage.getItem('lang');
      pt.Persons = [];

      try {
        pt.BIN = this.jurPerson.IDN;
        pt.token = this.token;
        console.log(event);
        let d = new Date();
        event.data.EDIT = '1';
        // event.data.ENDDATE = this.addNull(d.getDate()) + "." + this.addNull(d.getMonth() + 1) + "." + d.getFullYear();
        event.data.ENDDATE = this.addNull(d.getDate() - 1) + "." + this.addNull(d.getMonth() + 1) + "." + d.getFullYear();
        let detail = new PersonsClass(
          event.data.BEGINDATE,
          event.data.BIRTHDATE,
          event.data.EDIT,
          event.data.ENDDATE,
          event.data.FM,
          event.data.FT,
          event.data.G_PERSON,
          event.data.IDN,
          event.data.NM,
          event.data.PERIOD,
          event.data.SUM
        );
        //  console.log(event.data);
        pt.Persons.push(detail);

        let jsonString1 = JSON.stringify(pt);

        this.rest.saveEmployee(jsonString1).subscribe((data: any) => {

          console.log(data);
          //sessionStorage.setItem('persons',JSON.stringify(this.personsN));
          if (data.code == "-1") {
            event.confirm.reject();
            Swal.fire({
              text: data.message,
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
          }
          if (data.code == "0") {
            event.confirm.resolve();
            Swal.fire({
              text: this.translate.instant('ALERTNCHANGESAVED'),
              type: 'success',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
          }
        },
          error => {
            event.confirm.reject();
            Swal.fire({
              text: error.message,
              type: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: "#008e54"
            })
          });

      }
      catch (err) {
        console.log(err);
      }

    } else {
      event.confirm.reject();
    }
  }
  saveList() {
    this.saveButtonDisabled = true;
    try {
      let pt = new EmployeesClass();
      pt.Persons = [];


      pt.BIN = this.jurPerson.IDN;
      pt.token = this.token;
      pt.lang = sessionStorage.getItem('lang');
      for (let i = 0; i < this.pp.length; i++) {
        let detail = new PersonsClass(
          this.pp[i].BEGINDATE,
          this.pp[i].BIRTHDATE,
          this.pp[i].EDIT,
          this.pp[i].ENDDATE,
          this.pp[i].FM,
          this.pp[i].FT,
          this.pp[i].G_PERSON,
          this.pp[i].IDN,
          this.pp[i].NM,
          this.pp[i].PERIOD,
          ((this.pp[i].SUM == null || this.pp[i].SUM == '' || this.pp[i].SUM == undefined) ? this.pp[i].SUM = '0' : this.pp[i].SUM)
        );
        pt.Persons.push(detail);
      }
      this.pp = [];
      // for (let i=0; i < this.personsN2.length; i++)
      // {
      //   let detail = new PersonsClass(
      //   this.personsN[i].BEGINDATE,
      //   this.personsN[i].BIRTHDATE,
      //   this.personsN[i].EDIT ,
      //   this.personsN[i].ENDDATE ,
      //   this.personsN[i].FM ,
      //   this.personsN[i].FT,
      //   this.personsN[i].G_PERSON,
      //   this.personsN[i].IDN,
      //   this.personsN[i].NM,
      //   this.personsN[i].PERIOD,
      //   this.personsN[i].SUM,
      //   )   
      //   pt.Persons.push(detail);
      // }

      if (pt.Persons.length == 0) {
        Swal.fire({
          text: this.translate.instant('ALERTEMPTYSAVE'),
          type: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: "#008e54"
        });
        return;
      }
      let jsonString1 = JSON.stringify(pt);
      console.log(jsonString1);
      this.rest.saveEmployee(jsonString1).subscribe((data: any) => {

        if (data.code == "-1") {
          Swal.fire({
            text: data.message,
            type: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
          })
        }
        if (data.code == "0") {
          Swal.fire({
            text: this.translate.instant('ALERTNCHANGESAVED'),
            type: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
          })
        }
        if (data.code == "-4") {
          Swal.fire({
            text: data.message,
            type: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
          })
        }
      },
        error => {
          console.log(error);
        });
      sessionStorage.setItem('persons', JSON.stringify(this.personsN));
    }
    catch (e) {
      console.log('Error was fixed= ' + e)
      Swal.fire({
        text: this.translate.instant('ALERTTECHNICAL'),
        type: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: "#008e54"
      })
    }


  }
  public replaceKaz(inp: string) {
    return inp.replace("ј", "ә").replace("і", "і").replace("є", "ғ").replace("ї", "ү").replace("ў", "ұ").replace("ќ", "қ").replace("ґ", "ө").replace("ћ", "һ").replace("Ј", "Ә")
      .replace("І", "І").replace("Ѕ", "Ң").replace("Є", "Ғ").replace("Ї", "Ү").replace("Ў", "Ұ").replace("Ќ", "Қ").replace("Ґ", "Ө").replace("Ћ", "Һ");
  }
}
